import { InjectionToken } from '@angular/core'
import { GameSetupConfig } from 'game-setup-services'

export const gameSetupConfigToken = new InjectionToken<GameSetupConfig>(
  'GameSetupConfigToken',
)
